/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.setupWishlistObserver();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    this.refreshSwymWishlistButtonsHandler = this.refreshSwymWishlistButtons.bind(this);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.retrySwymWishlistButtonsInit();
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      this.retrySwymWishlistButtonsInit();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    if (this.crossSellObserver) this.crossSellObserver.disconnect();
  }

  setupWishlistObserver() {
    const crossSellsContainer = this.querySelector('[data-merge="cross-sells"]');
    if (!crossSellsContainer) return;

    this.crossSellObserver = new MutationObserver(() => {
      clearTimeout(this.swymRefreshTimeout);
      this.swymRefreshTimeout = setTimeout(this.refreshSwymWishlistButtonsHandler, 120);
    });

    this.crossSellObserver.observe(crossSellsContainer, { childList: true, subtree: true });
  }

  refreshSwymWishlistButtons() {
    if (!window._swat) return;

    const swymFns = [
      window._swat.initializeActionButtons,
      window._swat.reinitializeActionButtons,
      window._swat.ui && window._swat.ui.initializeActionButtons
    ].filter((fn) => typeof fn === 'function');

    swymFns.forEach((fn) => {
      try {
        fn.call(window._swat);
      } catch (error) {
        // Ignore Swym re-init errors and try remaining handlers.
      }
    });
  }

  retrySwymWishlistButtonsInit() {
    [0, 300, 900, 1600].forEach((delay) => {
      setTimeout(this.refreshSwymWishlistButtonsHandler, delay);
    });
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
